var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLogoLight(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 512,
    height: 512,
    viewBox: "0 0 512 512",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_214_85)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M157.308 182.461H129.103V330.539H157.308V267.077H241.924V330.539H270.13V267.077H354.746V330.539H382.952V238.872H382.952H354.746H270.13V182.461H241.924V238.872H157.308V182.461Z",
    fill: "#A1A1A1"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 143.205,
    cy: 353.751,
    r: 28.2054,
    fill: "#A1A1A1"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 256.027,
    cy: 353.751,
    r: 28.2054,
    fill: "#A1A1A1"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 368.849,
    cy: 353.751,
    r: 28.2054,
    fill: "#A1A1A1"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 143.205,
    cy: 159.249,
    r: 28.2054,
    fill: "#A1A1A1"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 256.027,
    cy: 159.249,
    r: 28.2054,
    fill: "#A1A1A1"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 256,
    cy: 256,
    r: 232,
    stroke: "#A1A1A1",
    strokeWidth: 48
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_214_85"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 512,
    height: 512,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoLight);
export default __webpack_public_path__ + "static/media/logo-light.c70517f2635c833033a9a3bfba866543.svg";
export { ForwardRef as ReactComponent };